import React, { FC } from 'react';
import { HStack, Stack, Text } from '@chakra-ui/react';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from '@app/components/Tooltip';

interface Props {
  data: {
    apr: number;
    tooltip: {
      label: string;
      value: string;
      color: string;
    }[];
  };
}

export const AprDetailsTooltip: FC<Props> = ({ data }) => {
  return (
    <Tooltip
      tooltip={
        <Stack p={0}>
          {data.tooltip?.map(item => {
            return (
              <HStack
                key={item.label}
                alignItems="center"
                justifyContent="space-between"
                gap="24px"
              >
                <Text fontSize="14px" color="neutral.400">
                  {item.label}
                </Text>
                <Text color={item.color} fontSize="14px">
                  {item.value}
                </Text>
              </HStack>
            );
          })}
        </Stack>
      }
      placement="top"
      zIndex={10000}
    >
      <FaInfoCircle color="#707070" />
    </Tooltip>
  );
};
